export default __webpack_public_path__ + "static/trustflight-logo-blue-248c64eddac40fb1f486475b967eda9f.svg";